import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import _regeneratorRuntime from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.regexp.replace";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import applyForm from "./applyForm.vue";
import { getCustomerList } from '@/views/cardSystem/customer/api/index';
import { getMyToDoList, getProjectDeliveryHandleType, submitProjectDeliveryHandle } from "../api";
export default {
  components: {
    applyForm: applyForm
  },
  data: function data() {
    return {
      companyList: [],
      searchForm: {
        status: [],
        type_of_demand: [],
        customer_id: null,
        pageSize: 20,
        page: 1
      },
      listData: [],
      listPages: {
        currentPage: 1,
        totalCount: 0
      },
      applyFormVisible: false,
      applyFormType: 'view',
      selectedId: null,
      // 处理弹窗
      processDialogVisible: false,
      processForm: {
        id: null,
        result: [],
        items: [],
        remarks: ''
      },
      processRules: {
        result: [{
          required: true,
          message: '请选择处理结果',
          trigger: 'change'
        }]
      }
    };
  },
  created: function created() {
    this.getCompanyList();
    this.getlist();
    if (this.$route.query.id) {
      var id = this.$route.query.id;
      var query = _objectSpread({}, this.$route.query);
      delete query.id;
      this.$router.replace({
        query: query
      });
      this.viewDetail(id);
    }
  },
  methods: {
    getCompanyList: function getCompanyList(val) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getCustomerList({
                page_size: 200,
                name: val || '',
                is_delete: 0
              });
            case 2:
              res = _context.sent;
              _this.companyList = res.data.list;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getlist: function getlist() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getMyToDoList(_this2.searchForm);
            case 2:
              res = _context2.sent;
              _this2.listData = res.data.data;
              _this2.listPages = res.pages;
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 翻页
    handlePageChange: function handlePageChange(page) {
      this.searchForm.page = page;
      var dom = document.getElementById('searchDom');
      dom.scrollIntoView();
      this.getlist();
    },
    sizeChange: function sizeChange(size) {
      this.searchForm.pageSize = size;
      this.searchForm.page = 1;
      this.getlist();
    },
    resetList: function resetList() {
      this.searchForm.page = 1;
      this.getlist();
    },
    handleClose: function handleClose() {
      this.getlist();
    },
    viewDetail: function viewDetail(id) {
      this.selectedId = id;
      this.applyFormType = 'view';
      this.applyFormVisible = true;
    },
    // 处理按钮点击事件
    handleProcess: function handleProcess(row) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res, data, items, result;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return getProjectDeliveryHandleType({
                id: row.id
              });
            case 2:
              res = _context3.sent;
              data = res.data || {};
              items = Array.isArray(data.items) ? data.items : [];
              result = items.filter(function (item) {
                return item.status == 1;
              }).map(function (item) {
                return item.type;
              });
              _this3.processForm.id = data.id || null;
              _this3.processForm.items = items;
              _this3.processForm.remarks = data.remarks || '';
              _this3.processForm.result = result;
              _this3.processDialogVisible = true;
              _this3.$nextTick(function () {
                _this3.$refs.processForm.clearValidate();
              });
            case 12:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    // 提交处理
    submitProcess: function submitProcess() {
      var _this4 = this;
      this.$refs.processForm.validate(function (valid) {
        if (valid) {
          _this4.submitFn();
        }
      });
    },
    submitFn: function submitFn() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var obj, res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              obj = JSON.parse(JSON.stringify(_this5.processForm));
              obj.items.forEach(function (item) {
                if (_this5.processForm.result.includes(item.type)) {
                  item.status = 1;
                } else {
                  item.status = 0;
                }
              });
              delete obj.result;
              _context4.next = 5;
              return submitProjectDeliveryHandle(obj);
            case 5:
              res = _context4.sent;
              _this5.$message.success('处理成功');
              _this5.processDialogVisible = false;
              _this5.getlist();
            case 9:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    }
  }
};